import { post } from "./requests";

export async function getToken({ user, password }) {
    return await post("auth/token", { user, password });
}

export async function getAutoToken({ user }) {
    return await post("auth/token", { user, auto: true });
}

export async function registerConnection({ token }) {
    return await post("auth/agent/connection", {}, token);
}
